<template>
    <div>
        <header-message class="text-success mt-5 mb-5">{{ message }}</header-message>
        <div class="buttonrow">
            <button-button class="btn btn-primary" type="submit" @click.prevent="acknowledgeClicked">Complete</button-button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { Global } from "@/support/GlobalData";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";
import { SignalR } from "@/support/SignalR";
import { CalibrationType } from "@/shared/enums/CalibrationType";

export default defineComponent({
    name: "CalibrationComplete",
    components: {
        HeaderMessage,
    },
    mixins: [PageBase],
    computed: {
        message(): string {
            if (Global.CalibrationSession?.CalibrationType === CalibrationType.Sequential)
                return "Targets have been successfully displayed.";
            else
                return "Target has been successfully displayed.";
        },
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onAcknowledgeByCompanion = this.acknowledgeClicked;
        SignalR.onCalibrationSuccess = (): void => {
            // no action (we sent it in successClicked), avoid out of sync popup
        };
        this.getCurrentStatusForListeners();
        CalibrationEventSupport.sendBatteryInformation();// send final battery info
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onAcknowledgeByCompanion = null;
        SignalR.onCalibrationSuccess = null;
    },
    methods: {
        acknowledgeClicked(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationEnded",
            } as DeviceStatusDto);

            Global.MainApp.clearSession();
            this.$router.push("/");
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationComplete",
            } as DeviceStatusDto);
        },
    },
});
</script>
